import { Link } from "react-router-dom";
import { Lockup } from "@ds/Mark";
import { COMPANY } from "../lib/company";
import "./footer.css";

const PRODUCTS = [
  { name: "BuildYourRack", href: "/products/buildyourrack", external: false },
  { name: "LogicDMX", href: "/products/logicdmx", external: false },
  { name: "Phase", href: "/products/phase", external: false },
  { name: "ST4SH", href: "/products/st4sh", external: false }
] as const;

const SITE_LINKS = [
  { to: "/products", label: "Products" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" }
] as const;

const LEGAL_LINKS = [
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/refunds", label: "Refund Policy" },
  { to: "/legal/cookies", label: "Cookies" },
  { to: "/legal/license", label: "Licensing" },
  { to: "/legal/imprint", label: "Legal notice" }
] as const;

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Lockup size={26} />
          <p className="footer__tagline">{COMPANY.tagline}</p>
          <p className="footer__small">
            {COMPANY.legalName} · {COMPANY.country}. Production technology for live entertainment, show
            control, and technical production workflows.
          </p>
          <p className="footer__small">
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
          </p>
        </div>

        <nav className="footer__links" aria-label="Products">
          <h3 className="footer__heading">Products</h3>
          {PRODUCTS.map((p) =>
            p.external ? (
              <a key={p.name} href={p.href} rel="noopener noreferrer">
                {p.name}
              </a>
            ) : (
              <Link key={p.name} to={p.href}>
                {p.name}
              </Link>
            )
          )}
        </nav>

        <nav className="footer__links" aria-label="Company">
          <h3 className="footer__heading">Company</h3>
          {SITE_LINKS.map((p) => (
            <Link key={p.to} to={p.to}>
              {p.label}
            </Link>
          ))}
        </nav>

        <nav className="footer__links" aria-label="Legal">
          <h3 className="footer__heading">Legal</h3>
          {LEGAL_LINKS.map((p) => (
            <Link key={p.to} to={p.to}>
              {p.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="container footer__bottom">
        <span className="footer__copyright">
          &copy; {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.
        </span>
        <span className="footer__build">
          v0.5.0 &middot; Build {new Date().getUTCFullYear()}.
          {String(new Date().getUTCMonth() + 1).padStart(2, "0")}
        </span>
      </div>
    </footer>
  );
}
